import React, { ReactElement } from 'react';

/**
 * ログイン画面用ヘッダーコンポーネント
 * @returns ReactElement<void>
 */
export function LoginHeader(): ReactElement<void> {
  return (
    <header className="login-head">
      <div className="l-inner">
        <div className="hd-wrap">
          <div className="logo">
            <a href="/login">
              <span className="img">
              <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="" />
              </span>
              <span className="txt">例会参加者管理システム</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

